<template lang="pug">
  v-flex.inicio-panel.cvc.mt-3(xs12 sm12 md12 lg12 style="padding-left: 10px;")
    v-layout#main-cvc-content(row wrap v-if="!sectionEnterDataPayment && !sectionCtaPayment && !sectionSuccessfullChangePayment && !sectionThankPayment")
      v-flex(xs12 md1 lg1)
      v-flex(xs12 md10 lg10)
        v-layout(row wrap)
          v-flex.title-cvc(xs12 md12 lg12)
            h1.omnesMedium Tus seguros
          v-flex.subtitle-cvc(xs12 md12 lg12)
            p(style="padding-right: 10px;") Selecciona los seguros en los que deseas actualizar el método de pago
            p &nbsp;
        v-layout.wrapper-list-of-policy(row wrap v-for="(poliza, index) in polizasVidaAvailable" :key="poliza.policyNumber" v-if="index%2==0")
          //- CENTRAR SI SOLO ES 1 PÓLIZA
          v-flex(:md3="polizasVidaAvailable.length < 2" :lg3="polizasVidaAvailable.length < 2")
          v-flex(xs12 :md5="polizasVidaAvailable.length > 1" :lg5="polizasVidaAvailable.length > 1" :md6="polizasVidaAvailable.length < 2" :lg6="polizasVidaAvailable.length < 2" style="padding-right: 10px;")
            v-card
              v-card-title
                v-flex
                  p.omnesMedium {{ poliza.name }}
              v-card-text.box-information
                v-layout(wrap)
                  v-flex(xs12 md12 lg12)
                    v-layout.ly-item-data-poliza(wrap)
                      v-flex(xs6 md5 lg5)
                        p.omnesRegular N° de poliza
                      v-flex(xs6 md7 lg7)
                        p.omnesMedium {{ poliza.policyNumber }}
                    v-layout.ly-item-data-poliza(wrap)
                      v-flex(xs6 md5 lg5)
                        p.omnesRegular Método de pago
                      v-flex(xs6 md7 lg7)
                        p.omnesMedium {{ (cardTypes.includes(poliza.paymentMethod.toLowerCase()))?`Tarjeta ${poliza.paymentMethod}`:poliza.paymentMethod }}
                    v-layout.ly-item-data-poliza(wrap)
                      v-flex(xs6 md5 lg5)
                        p.omnesRegular Frecuencia de pago
                      v-flex(xs6 md7 lg7)
                        p.omnesMedium {{ poliza.charge }}
                    v-layout.ly-item-data-poliza(wrap)
                      v-flex(xs6 md5 lg5)
                        p.omnesRegular Monto de cuota
                      v-flex(xs6 md7 lg7)
                        p.omnesMedium {{ poliza.coinSymbol + ' ' + poliza.quota }}
                v-layout.box-btn-selected(wrap)
                  v-btn.omnesMedium(@click="selectProduct($event, poliza.policyNumber)" :id="'btn_' + poliza.policyNumber")
                    img.check-custom-icon(:src="iconCircleSelected" v-if="isSelected(poliza.policyNumber)")
                    img.check-custom-icon(:src="iconCircleUnselected" v-else)
                    span.custom-text Seleccionar
          v-flex(:md3="polizasVidaAvailable.length < 2" :lg3="polizasVidaAvailable.length < 2")
          //- CENTRAR SI SOLO SON MAS DE 2 PÓLIZAS
          v-flex(xs12 :md2="polizasVidaAvailable.length > 1" :lg2="polizasVidaAvailable.length > 1")
          v-flex(xs12 md5 lg5 v-if="polizasVidaAvailable[index+1] != null" style="padding-right: 10px;")
            v-card
              v-card-title
                v-flex
                  p.omnesMedium {{ polizasVidaAvailable[index+1].name }}
              v-card-text.box-information
                v-layout(wrap)
                  v-flex(xs12 md12 lg12)
                    v-layout.ly-item-data-poliza(wrap)
                      v-flex(xs6 md5 lg5)
                        p.omnesRegular N° de póliza
                      v-flex(xs6 md7 lg7)
                        p.omnesMedium {{ polizasVidaAvailable[index+1].policyNumber }}
                    v-layout.ly-item-data-poliza(wrap)
                      v-flex(xs6 md5 lg5)
                        p.omnesRegular Método de pago
                      v-flex(xs6 md7 lg7)
                        p.omnesMedium {{ (cardTypes.includes(polizasVidaAvailable[index+1].paymentMethod.toLowerCase()))?`Tarjeta ${polizasVidaAvailable[index+1].paymentMethod}`:polizasVidaAvailable[index+1].paymentMethod }}
                    v-layout.ly-item-data-poliza(wrap)
                      v-flex(xs6 md5 lg5)
                        p.omnesRegular Frecuencia de pago
                      v-flex(xs6 md7 lg7)
                        p.omnesMedium {{ polizasVidaAvailable[index+1].charge }}
                    v-layout.ly-item-data-poliza(wrap)
                      v-flex(xs6 md5 lg5)
                        p.omnesRegular Monto de cuota
                      v-flex(xs6 md7 lg7)
                        p.omnesMedium {{ polizasVidaAvailable[index+1].coinSymbol + ' ' + polizasVidaAvailable[index+1].quota }}
                v-layout.box-btn-selected(wrap)
                  v-btn.omnesMedium(@click="selectProduct($event, polizasVidaAvailable[index+1].policyNumber)" :id="'btn_' + polizasVidaAvailable[index+1].policyNumber")
                    img.check-custom-icon(:src="iconCircleSelected" v-if="isSelected(polizasVidaAvailable[index+1].policyNumber)")
                    img.check-custom-icon(:src="iconCircleUnselected" v-else)
                    span.custom-text Seleccionar
        v-layout.btn-process-all(row wrap v-if="!$vuetify.breakpoint.smAndDown")
          v-flex(xs12 md12 lg12 style="text-align:center;margin-bottom:1em;")
            v-btn#btn_update_payment.omnesMedium(@click="goToConfirmChange()" :disabled="disabledButton")
              span(v-if="productSelected > 0") {{ productSelected }}
              | ACTUALIZAR MÉTODO DE PAGO
          v-flex(xs12 md12 lg12 style="text-align:center;")
            a.omnesMedium(href="#" @click="goHome()") Volver
      v-flex(xs12 md1 lg1)
    //- [BTN-FLOATING]
    v-btn#btn-floatting.omnesMedium(@click="goToConfirmChange()" :disabled="disabledButton" v-if="$vuetify.breakpoint.smAndDown && productSelected > 0 && showFloatingBtn")
      span {{ productSelected }}
      | ACTUALIZAR MÉTODO DE PAGO
    //- [INITIAL-DIALOG]
    v-dialog(v-model="dialogCVC" max-width="480px" :persistent="true")
      v-card#info-cvc
        v-card-title
          v-flex
            h1.omnesMedium.text-xs-center Cómo puedes cambiar el
              br
              | método de pago
        v-card-text
          v-layout(wrap v-for="(item, index) in popUpData" :key="index")
            v-flex(xs12 md12 lg12)
              v-layout.item-step(wrap)
                v-flex.info-step-icon(xs2 md12 lg12)
                  img(:src="item.icon")
                v-flex.info-step-text(xs10 md12 lg12)
                  p {{item.text}}
          v-card-actions
            v-layout
              v-flex.text-xs-center
                v-btn.omnesSemibold(color="dark" @click="accept()") Entendido
    //- [SECOND-DIALOG]
    v-dialog(v-model="dialogCardIndications" max-width="480px" :persistent="true")
      v-card#info-cvc
        v-card-title
          v-flex
            h1.omnesMedium.text-xs-center Antes de pagar no olvides:
        v-card-text
          v-layout(wrap v-for="(item, index) in popUpIndications" :key="index")
            v-flex
              v-layout
                v-flex.info-step-icon
                  img(:src="item.icon" style="margin-top: 10px;")
                v-flex(style="margin-left: 15px;text-align: justify;")
                  p(v-html="item.text")
          v-card-actions
            v-layout
              v-flex.text-xs-center
                v-btn.omnesMedium(color="dark" @click="dialogCardIndications = false") Continuar
    //- [ENTER DATA PAYMENT]
    v-layout#enter-data-payment(row wrap v-if="sectionEnterDataPayment")
      v-flex(xs12 md2 lg2)
      v-flex(xs12 md8 lg8)
        v-layout(row wrap)
          v-flex(xs12 md3 lg3)
          v-flex.container-data-payment(xs12 md12 lg12 style="margin-top: 0; padding-top: 0;")
            v-layout(row wrap)
              v-flex.title-cvc(xs12 md12 lg12)
                h1.omnesMedium Ingresa los datos de tu tarjeta
              v-flex.subtitle-cvc(xs12 md12 lg12)
                p(style="padding-right: 10px;") Para actualizar el método de pago, ingresa los datos de la tarjeta de crédito/débito
              v-flex.second-subtitle-cvc(xs12 md12 lg12)
                p.omnesMedium
                  img(:src="iconSeguridad" width="17px" alt="iconSeguridad")
                  | Te encuentras en un ambiente 100 % seguro

            v-card#form-credit-card-payment-method
              v-card-text
                v-layout(wrap row v-if="niubiz.finishGetSessionKey")
                  .i-interseguro__content__form
                    Niubiz(
                      :configuration="niubiz.configuration"
                      :elementStyle="niubiz.styles"
                      :dataClient="niubiz.pagador"
                      :showTermsConditions="true"
                      :showCheckRecurrent="niubiz.checkRecurrent"
                      :showCheckOptionTrue="niubiz.checkRecurrente"
                      :buttonText="niubiz.botonTexto"
                      :vuetifyStyle="niubiz.vuetify"
                      @openloader="showLoader"
                      @hideloader="hideLoader"
                      @carderror="onPaymentError"
                      @open-conditions="showTerms"
                    )
                v-card-actions.update-payment-actions(style="text-align:center; justify-content:center;")
                  v-layout
                    v-flex.text-xs-center
                      a.omnesMedium(href="#" @click="closeDialogMethodPayment($event)") Volver
          v-flex(xs12 md3 lg3)
      v-flex(xs12 md2 lg2)
    //- [SUCCESSFULL CHANGE PAYMENT]
    v-layout#successfull_change_payment(row wrap v-if="sectionSuccessfullChangePayment")
      v-flex(xs12 md2 lg2)
      v-flex(xs12 md8 lg8)
        v-layout(row wrap)
          v-flex(xs12 :md3="windowInnerWidth > 1265 && windowInnerWidth < 1750" :md4="windowInnerWidth > 1750" :lg3="windowInnerWidth > 1265 && windowInnerWidth < 1750" :lg4="windowInnerWidth > 1750")
          v-flex.container-sucessfull(xs12 :md6="windowInnerWidth > 1265 && windowInnerWidth < 1750" :md4="windowInnerWidth > 1750" :lg6="windowInnerWidth > 1265 && windowInnerWidth < 1750" :lg4="windowInnerWidth > 1750")
            v-layout(row wrap)
              v-flex.title-cvc(xs12 md12 lg12)
                img(:src="iconShieldSuccessfull")
                h1.omnesMedium Tu método de pago se ha actualizado con éxito
                p.parraf-response.omnesRegular(style="color:#EA0D90") Tu nuevo método de pago será procesado en los próximos 4 días
            v-layout(wrap row)
              p.omnesMedium.subtitle Cambiaste el método de pago de:
            v-layout.info-creditcard(wrap row)
              v-flex(xs12 md12 lg12)
                v-card.successfull-card(v-if="(cvcInfo.subscriptions).length > 0" v-for="(poliza, index) in cvcInfo.subscriptions" :key="poliza.metadata.numeroPoliza")
                  v-layout.ly-success-info(row wrap)
                    v-flex.success-info-title(xs12 md4 lg4)
                      p.omnesRegular Producto:
                    v-flex.success-info-data(xs7 md7 lg7)
                      p.omnesMedium {{ poliza.name }}
                  v-layout.ly-success-info(row wrap)
                    v-flex.success-info-title(xs12 md4 lg4)
                      p.omnesRegular N° de Póliza:
                    v-flex.success-info-data(xs7 md7 lg7)
                      p.omnesMedium {{ poliza.metadata.numeroPoliza }}
            p.parraf-response.omnesRegular Ingresa un correo electrónico al que quieras enviar la confirmación de la solicitud
            v-card#form-response-medium(style="box-shadow:none")
              v-card-text
                v-layout(wrap row)
                  v-flex(sm12 md12 lg12)
                    v-text-field(outline hide-details placeholder="Correo electrónico" v-model="basicInfo.correo")
                      template(v-slot:append='')
                        img(:src="iconPencil" alt="alt-pencil")
            v-card-actions.update-payment-actions
              v-layout
                v-flex.text-xs-center
                  v-btn.omnesMedium(color="dark" @click="makeSendEmail()") ENVIAR
          v-flex(xs12 :md3="windowInnerWidth > 1265 && windowInnerWidth < 1750" :md4="windowInnerWidth > 1750" :lg3="windowInnerWidth > 1265 && windowInnerWidth < 1750" :lg4="windowInnerWidth > 1750")
      v-flex(xs12 md2 lg2)
    //- [ENTER CTA]

    //- [TERMINOS Y CONDICIONES]
    v-dialog(v-model="dialogTerms" max-width="800px")
      v-card#dialogTermsCard
        v-card-text
          v-layout(wrap)
            v-flex.wrapper-btn-close(xs12 md12 lg12)
              div(style="cursor: pointer; position: absolute; top: 15px; right: 15px; z-index: 99;")
                img(:src="iconBtnClose" alt="iconBtnClose" @click="dialogTerms = false" style="width: 30px;")
            v-flex.wrapper-title(xs12 md12 lg12)
              v-layout(wrap style="margin-top: 20px;")
                h3 Términos y condiciones
                p
                  |
                p(v-for="line of termsConditions")
                  | {{ line }}
    //- LOADER PROCESS
    v-dialog(v-model="loader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Corroborando y obteniendo información...
          v-progress-linear.mb-0(indeterminate="" color="white")
    //- 2do LOADER PROCESS
    v-dialog(v-model="loader2" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | {{ txtLoader2 }}
          v-progress-linear.mb-0(indeterminate="" color="white")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Niubiz from '@/components/payment/Niubiz'
import paymentTerms from './../interfaces/paymentsTerms'
import paymentErrors from './../interfaces/paymentErrors'
import Functionalities from '../interfaces/functionalities'

const KEY_BACK_RETURN = 'backReturn'
const IP_ADDR = 'ipaddress'
const KEY_BACK_HOME = 'backHome'
const KEY_CVC_SUCCESS = 'cvcSuccess'
const KEY_CVC_RETRIES = 'cvcRetries'
const VALUE_YES = '1'
const VALUE_NO = '0'
const REGEX_CARDS = [
  {re: '^4[0-9]{5}$', value: 'visa'},
  {re: '^5[1-5][0-9]{4}$', value: 'mastercard'},
  {re: '^3[47][0-9]{4}$', value: 'amex'},
  {re: '^3(?:0[0-5]|[68][0-9])[0-9]{3}$', value: 'dinners'}
]

export default {
  props: ['polizaInput'],
  data () {
    return {
      today: '',
      polizasVidaAvailable: [],
      polizasSeleccionadas: [],
      polizasNoSeleccionadas: [],
      loader: false,
      loader2: false,
      txtLoader2: '',
      dialogCVC: false,
      dialogCardIndications: false,
      showFloatingBtn: false,
      dialogMethodPayment: false,
      dialogEnviarConstancia: false,
      dialogTerms: false,
      iconBtnPlus: {
        disabled: require('./../assets/cambio-cobro/icon-btn-plus.svg'),
        focused: require('./../assets/cambio-cobro/icon-btn-plus-selected.svg'),
        current: require('./../assets/cambio-cobro/icon-btn-plus.svg')
      },
      iconPencil: require('./../assets/cambio-cobro/icon-pencil.svg'),
      iconEnviarMensaje: require('./../assets/cambio-cobro/icon-enviar-mensaje.svg'),
      iconSeguridad: require('./../assets/cambio-cobro/icon-seguridad.svg'),
      iconEnvioConstancia: require('./../assets/cambio-cobro/icon-envio-constancia.svg'),
      iconMensajeria: require('./../assets/cambio-cobro/icon-mensajeria.svg'),
      iconBtnClose: require('./../assets/cambio-cobro/btn-close.svg'),
      iconShieldSuccessfull: require('./../assets/cambio-cobro/icon-shield-successfull.svg'),
      iconCircleUnselected: require('./../assets/cambio-cobro/icon-circle-unselected.svg'),
      iconCircleSelected: require('./../assets/cambio-cobro/icon-circle-selected.svg'),
      icons: {
        oops: require('@/assets/characters/oops.svg')
      },
      sectionEnterDataPayment: false,
      sectionSuccessfullChangePayment: false,
      sectionThankPayment: false,
      sectionCtaPayment: false,
      productSelected: 0,
      disabledButton: true,
      windowInnerWidth: 0,
      typeChangePayment: 'current',
      popUpData: [
        {
          icon: require('./../assets/cambio-cobro/icon-shield.svg'),
          text: 'Selecciona el seguro o los seguros en los que deseas actualizar el método de pago.'
        },
        {
          icon: require('./../assets/cambio-cobro/icon-card-reload.svg'),
          text: 'Actualiza o ingresa tu tarjeta de débito o crédito.'
        },
        {
          icon: require('./../assets/cambio-cobro/icon-eye.svg'),
          text: 'Verifica tus datos actualizados.'
        },
        {
          icon: require('./../assets/cambio-cobro/icon-handup.svg'),
          text: '¡Listo! Ya tienes un nuevo método de pago activado.'
        }
      ],
      popUpIndications: [
        {
          icon: require('./../assets/cambio-cobro/icon-shield.svg'),
          text: 'Activar la <strong>compra online</strong> en tu tarjeta de débito o crédito.'
        },
        {
          icon: require('./../assets/cambio-cobro/icon-card-reload.svg'),
          text: 'Revisar los <strong>límites de compra y saldo</strong> de tu tarjeta.'
        },
        {
          icon: require('./../assets/cambio-cobro/icon-eye.svg'),
          text: 'Si eres cliente del <strong>BBVA</strong>, recuerda que debes obtener el código CVV desde el app de tu banco.'
        }
      ],
      niubiz: {
        configuration: {
          sessionkey: '',
          channel: 'paycard',
          merchantid: '',
          purchasenumber: '', // Poliza
          amount: '1', // El precio a cobrar
          // callbackurl: process.env.LANDING_URL + 'payment-api/api/v2/token?protocol=http&host=localhost:8083/zona-segura/&path=/cambio-via-cobro',
          callbackurl: process.env.LANDING_PAYMENT_URL + 'payments/tokens?protocol=' + process.env.LANDING_PROTOCOL + '&host=' + process.env.LANDING_HOST + '/zona-segura&path=/cambio-via-cobro',
          language: 'es',
          font: 'https://fonts.googleapis.com/css?family=Montserrat:400&display=swap',
          recurrentmaxamount: '1' // Máx. pago
        },
        styles: {
          base: {
            color: '#495057',
            fontWeight: 500,
            fontFamily: '"Montserrat", sans-serif',
            fontSize: '16px',
            fontSmoothing: 'antialiased',
            placeholder: {
              color: '#c4c4c4'
            },
            autofill: {
              color: '#e39f48'
            }
          },
          invalid: {
            color: '#dc3545',
            '::placeholder': { color: '#FFCCA5' }
          }
        },
        pagador: {
          name: '',
          lastName: ' ',
          email: '',
          alias: '',
          userBlockId: ''
        },
        dataSession: {
          apiKey: '',
          currency: '',
          amount: '1',
          clientIP: '192.168.0.1',
          merchantDefineData: {}
        },
        finishGetSessionKey: false,
        vuetify: true,
        checkRecurrente: false,
        checkAccept: false,
        botonTexto: 'REALIZAR CAMBIO'
      },
      termsConditions: [],
      cvcResponse: '',
      cardTypes: ['visa', 'mastercard', 'amex', 'american express', 'dinners'],
      trackEvents: {
        access: {
          category: 'Cambio de Via de Cobro',
          action: 'Acceso',
          label: 'Acceso OK',
          event: 'CVC Acceso',
          producto: ''
        },
        accessForm: {
          category: 'Cambio de Via de Cobro',
          action: 'Acceso',
          label: 'Acceso Formulario OK',
          event: 'CVC Acceso Formulario',
          producto: ''
        },
        cvcSuccess: {
          category: 'Cambio de Via de Cobro',
          action: 'Acceso',
          label: 'Registro Exitoso',
          event: 'CVC Exitoso',
          producto: ''
        },
        mailingSuccess: {
          category: 'Cambio de Via de Cobro',
          action: 'Acceso',
          label: 'Envio de Correo Exitoso',
          event: 'CVC Correo Exitoso',
          producto: ''
        },
        policiesNotFound: {
          category: 'Cambio de Via de Cobro',
          action: 'Error',
          label: 'Sin Polizas para realizar CVC',
          event: 'CVC Sin Polizas',
          producto: ''
        },
        policiesError: {
          category: 'Cambio de Via de Cobro',
          action: 'Error',
          label: 'Error Consulta Polizas',
          event: 'CVC Polizas Error',
          producto: ''
        },
        serverError: {
          category: 'Cambio de Via de Cobro',
          action: 'Error',
          label: 'Error de Servidor',
          event: 'CVC Server Error',
          producto: ''
        },
        formError: {
          category: 'Cambio de Via de Cobro',
          action: 'Error',
          label: 'Error de Formulario de Pago',
          event: 'CVC Error Formulario Pago',
          producto: ''
        },
        mailingError: {
          category: 'Cambio de Via de Cobro',
          action: 'Error',
          label: 'Error de Envio de Correo',
          event: 'CVC Error Correo',
          producto: ''
        }
      },
      amplitude: {
        events: {
          intentionChangeCVC: 'Intención de Cambio CVC',
          cVCChangeConfirmation: 'Confirmacion de Cambio CVC',
          cVCChangeError: 'Error de Cambio CVC'
        }
      }
    }
  },
  watch: {
    productSelected: function (val) {
      if (val < 1) {
        this.disabledButton = true
      } else {
        this.disabledButton = false
      }
    }
  },
  methods: {
    ...mapActions('user', ['getCustomerData', 'getSessionKey']),
    ...mapActions('cvc', ['registerCVC', 'sendMailCVC']),
    accept () {
      this.dialogCVC = false
    },
    makeSendEmail () {
      this.loader = true
      let policies = ''
      for (let i = 0; i < this.cvcInfo.subscriptions.length; i++) {
        policies += `<table border="0" cellpadding="0" cellspacing="0" style="width: 100%;"><tr>
          <td align="center" style="display: block; width: auto; height: 50px; line-height: 20px;font-family: Arial, sans-serif; padding: 20px 30px; border-radius: 0; background-color:#deeafd;border-bottom: 1px solid white;">
          <table border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
          <tr>${(i === 0) ? '<td align="left" width="200">Tu(s) póliza(s)</td>' : ''}<td align="right"><span><b>${this.cvcInfo.subscriptions[i].name}</b></span></td></tr>
          <tr><td align="right" colspan="2" style="font-size: 13px"><span>Número de Póliza </span><span>${this.cvcInfo.subscriptions[i].objectId}</span></td>
          </tr></table></td></tr></table>`
      }
      const products = this.cvcInfo.subscriptions[0].objectId

      let data = {
        'nombre': this.cvcInfo.customer.name || ' ',
        'correo': this.basicInfo.correo,
        'tarjeta': this.cvcResponse.card.number || ' ',
        'polizas': policies || ''
      }
      localStorage.setItem(KEY_CVC_SUCCESS, VALUE_NO)
      this.sendMailCVC(data)
        .then((res) => {
          this.loader = false
          if (res.status === 200 && res.data.includes('OK')) {
            // this.dialogEnviadoConstancia = true
            this.$swal({
              title: 'Estimado cliente',
              text: 'Te enviamos la constancia a tu correo.',
              confirmButtonText: 'Ok'
            }).then((result) => {
              this.trackEvents.mailingSuccess.producto = products
              this.$gtm.trackEvent(this.trackEvents.mailingSuccess)
              this.$router.push('/inicio')
            })
          } else {
            this.trackEvents.mailingError.producto = products
            this.$gtm.trackEvent(this.trackEvents.mailingError)
            this.$swal({
              title: '¡Oops, algo salió mal!',
              text: 'No se pudo enviar el correo. Te pedimos disculpas por el inconveniente. Por favor, inténtalo nuevamente en unos minutos.',
              imageUrl: this.icons.oops,
              confirmButtonText: 'Ok'
            })
          }
        })
        .catch(() => {
          this.loader = false
          this.trackEvents.mailingError.producto = products
          this.$gtm.trackEvent(this.trackEvents.mailingError)
          this.$swal({
            title: '¡Oops, algo salió mal!',
            text: 'No se pudo enviar el correo. Te pedimos disculpas por el inconveniente. Por favor, inténtalo nuevamente en unos minutos.',
            imageUrl: this.icons.oops,
            confirmButtonText: 'Ok'
          })
        })
    },
    downloadFile (evt) {
      evt.preventDefault()
    },
    selectProduct (evt, numeroPoliza) {
      let self = this
      self.showFloatingBtn = true
      self.polizasNoSeleccionadas = []
      let elementToCheck = document.getElementById('btn_' + numeroPoliza)
      // VERIFY EL
      if (elementToCheck.classList.contains('active')) {
        elementToCheck.classList.remove('active')
        elementToCheck.querySelector('span.custom-text').innerText = 'Seleccionar'
        // Identificar que poliza selecciono para quitarlo
        self.polizasSeleccionadas = this.polizasSeleccionadas.filter(r => {
          return r.policyNumber !== numeroPoliza
        })
        self.productSelected--
      } else {
        elementToCheck.classList.add('active')
        elementToCheck.querySelector('span.custom-text').innerText = 'Seleccionado'
        // Identificar que poliza selecciono para agregarlo
        let polizaSeleccionada = self.polizasVidaAvailable.filter(r => {
          return r.policyNumber === numeroPoliza
        })
        self.polizasSeleccionadas.push(polizaSeleccionada[0])
        self.productSelected++
      }
      // Identificar que poliza NO ah sido seleccionada
      let polizasPreviamenteSeleccionadas = self.polizasSeleccionadas.map(f => { return f.policyNumber })
      self.polizasVidaAvailable.forEach(el => {
        if (polizasPreviamenteSeleccionadas.indexOf(el.policyNumber) < 0) {
          self.polizasNoSeleccionadas.push(el)
        }
      })
    },
    isSelected (numeroPoliza) {
      const span = document.querySelector('#btn_' + numeroPoliza + ' span.custom-text')
      if (span == null) {
        return false
      }
      const text = span.innerText
      if (text === 'Seleccionado') {
        return true
      } else {
        return false
      }
    },
    removeAcents (cadena) {
      const acentos = {'%': '', 'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u', 'Á': 'A', 'É': 'E', 'Í': 'I', 'Ó': 'O', 'Ú': 'U'}
      return cadena.split('').map(letra => acentos[letra] || letra).join('').toString()
    },
    selectPaymentMethod (evt, type) {
      let anotherPayments = document.querySelectorAll('.another-method-payment')
      let currentPayment = document.querySelectorAll('.current-method-payment')
      anotherPayments.forEach(el => { el.classList.remove('active') })
      currentPayment.forEach(el => { el.classList.remove('active') })
      let parentElementIfExist = null
      // SI LE HACEN CLICK AL PARRAFO, SUBIR UN NIVEL PARA LLEGAR AL DIV
      if (evt.target.nodeName === 'P' || evt.target.nodeName === 'IMG') {
        parentElementIfExist = evt.target.parentElement
      } else {
        parentElementIfExist = evt.target
      }
      parentElementIfExist.classList.add('active')
      // REMOVE IMAGE FOCUSED. PUT NORMAL IMAGE
      let imagesAnotherPayments = document.querySelectorAll('#info-methods .box-another-options-payments .another-method-payment img.btn-plus')
      imagesAnotherPayments.forEach(el => {
        el.setAttribute('src', this.iconBtnPlus.disabled)
      })
      if (parentElementIfExist.classList.contains('another-method-payment')) {
        parentElementIfExist.firstElementChild.setAttribute('src', this.iconBtnPlus.focused)
      }
      this.typeChangePayment = type
    },
    backToEditInfoPayment () {
      this.sectionEnterDataPayment = true
      this.sectionSuccessfullChangePayment = false
    },
    goUpdatePaymentMethod () {
      this.dialogMethodPayment = true
      let anotherPayments = document.querySelectorAll('.another-method-payment')
      anotherPayments.forEach(el => { el.classList.remove('active') })
      let imagesAnotherPayments = document.querySelectorAll('#info-methods .box-another-options-payments .another-method-payment img.btn-plus')
      imagesAnotherPayments.forEach(el => {
        el.setAttribute('src', this.iconBtnPlus.disabled)
      })
    },
    goToVerifyData () {
      this.sectionEnterDataPayment = false
      this.sectionCtaPayment = false
      // this.sectionVerifyDataPayment = true
    },
    setConditionTermns () {
      this.termsConditions = paymentTerms.mix
      this.polizasSeleccionadas.map(poliza => poliza.policyName.toUpperCase().includes('VEHICULAR') ? 'vehicular' : 'vida')
      if (this.polizasSeleccionadas.length > 1 && this.polizasSeleccionadas.includes('vehicular') && this.polizasSeleccionadas.includes('vida')) {
        this.termsConditions = paymentTerms.mix
      } else if (this.polizasSeleccionadas.includes('vehicular')) {
        this.termsConditions = paymentTerms.vehicular
      } else {
        this.termsConditions = paymentTerms.vida
      }
    },
    goToConfirmChange () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.CVC, self.functionsRules, self)) {
        return
      }
      
      // Validación por producto
      const polizaBloqueada = self.polizasSeleccionadas.find(poliza => 
        !Functionalities.isAvailableSilent(Functionalities.vida.CVC, self.functionsRules, poliza.name)
      )
      if (polizaBloqueada) {
        Functionalities.isAvailable(Functionalities.vida.CVC, self.functionsRules, self, polizaBloqueada.name)
        return
      }
      
      this.setConditionTermns()
      localStorage.setItem(KEY_BACK_RETURN, VALUE_YES)
      var segurosSeleccionados = self.polizasSeleccionadas.length
      var frecuenciaPago = self.polizasSeleccionadas.map((el) => { return el.charge })
      var cuotaPagar = self.polizasSeleccionadas.map((el) => { return el.quota })
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.intentionChangeCVC,
          {
            'CVC Seguros seleccionados': segurosSeleccionados,
            // 'Emisor de la Tarjeta': '',
            'Frecuencia de pago': frecuenciaPago,
            'Monto a pagar': cuotaPagar
          }
        )
      self.showFloatingBtn = false
      // COMPLETANDO INFORMACIÓN DE POLIZA
      self.niubiz.configuration.purchasenumber = new Date().getTime() + ''
      self.niubiz.configuration.amount = parseFloat(1)
      self.niubiz.configuration.recurrentmaxamount = parseFloat(1)
      // COMPLETANDO INFORMACIÓN DE CLIENTE
      self.niubiz.pagador.name = self.removeAcents(self.basicInfo.nombres).slice(0, 24)
      self.niubiz.pagador.lastName = self.removeAcents(self.basicInfo.apellidoPaterno + ' ' + self.basicInfo.apellidoMaterno).slice(0, 24)
      self.niubiz.pagador.email = self.basicInfo.correo
      self.niubiz.pagador.alias = self.removeAcents(self.basicInfo.nombres).slice(0, 24)
      self.niubiz.pagador.userBlockId = self.basicInfo.numeroDocumento
      // COMPLETANDO INFORMACIÓN DE PAGO
      self.niubiz.dataSession.currency = self.polizasSeleccionadas[0].coin || 'PEN'
      self.niubiz.dataSession.amount = parseFloat(1)
      // - INFORMACION: http://mdd.evirtuales.com/ con código 6300
      self.niubiz.dataSession.merchantDefineData = {
        MDD1: self.basicInfo.celular,
        MDD2: self.basicInfo.correo,
        MDD3: self.polizasSeleccionadas[0].policyNumber,
        MDD4: self.basicInfo.correo,
        MDD21: '1',
        MDD32: self.basicInfo.numeroDocumento,
        MDD34: self.basicInfo.numeroDocumento,
        MDD37: '1',
        MDD63: self.basicInfo.tipoDocumento,
        MDD70: '1',
        MDD75: 'Cliente',
        MDD77: '159'
      }
      // CARGANDO INFO PARA EL FORM NIUBIZ PARA SER USADA NUEVAMENTE DESPUES DE LA RESPUESTA DEL PAYMENT-API
      let currentDate = (new Date()).toISOString().slice(0, 19).replace('T', ' ')
      let hash = {
        token: '',
        merchant_id: '',
        xPaymentApiKey: '',
        currency: self.polizasSeleccionadas[0].coin,
        ip: self.niubiz.dataSession.clientIP,
        customer: {
          email: self.basicInfo.correo,
          documentType: self.basicInfo.tipoDocumento,
          documentNumber: self.basicInfo.numeroDocumento,
          country: 'PE',
          name: self.basicInfo.nombres,
          lastName: self.basicInfo.apellidoPaterno,
          motherLastName: self.basicInfo.apellidoMaterno,
          phone: self.basicInfo.celular,
          address: 'PE',
          addressCity: 'Lima',
          metadata: {}
        },
        subscriptions: []
      }
      // El comercio (merchant_id) lo resuelve el BFF al crear la sesión: ver loadNiubizSessionKey
      // AGREGANDO LOS SUBS DEPENDIENDO DE LA CANTIDAD DE POLIZAS ELEGIDAS
      for (let jndex = 0; jndex < (self.polizasSeleccionadas).length; jndex++) {
        // FORMANDO JSON POR SUB
        let sub = {
          objectId: self.polizasSeleccionadas[jndex].policyNumber,
          currency: self.polizasSeleccionadas[jndex].coin,
          productName: self.polizasSeleccionadas[jndex].policyName,
          name: self.polizasSeleccionadas[jndex].name,
          amount: parseFloat(self.polizasSeleccionadas[jndex].quota),
          metadata: {
            numeroPoliza: self.polizasSeleccionadas[jndex].policyNumber
          },
          metadataAffiliation: {
            cliente: {
              apellidopaterno: self.basicInfo.apellidoPaterno,
              apellidomaterno: self.basicInfo.apellidoMaterno,
              documentoidentidad: self.basicInfo.numeroDocumento,
              nombre: self.basicInfo.nombres,
              tipodocumento: self.basicInfo.tipoDocumento === 'DNI' ? 1 : 2
            },
            afiliacion: {
              fechaingresomandato: currentDate,
              moneda: self.polizasSeleccionadas[jndex].coin,
              numeropropuesta: '',
              numeropoliza: self.polizasSeleccionadas[jndex].policyNumber,
              periodopago: self.polizasSeleccionadas[jndex].charge.toUpperCase(),
              tipooperacion: 1,
              codusuariocreador: '',
              fechaOperacion: currentDate,
              datoadicional: ''
            },
            tarjeta: {
              fechavencimientocadena: '',
              moneda: self.polizasSeleccionadas[jndex].coin,
              numerotarjeta: '',
              numerocuenta: '',
              tipocuenta: 0,
              tipoviacobro: 2,
              viacobro: 8
            },
            tarjeta_pp: {
              fechavencimiento: '',
              moneda: self.polizasSeleccionadas[0].coin,
              numerotarjeta: '',
              numerocuenta: '',
              tipocuenta: 0,
              tipoviacobro: 2,
              viacobro: 8
            }
          }
        }
        // AGREGANDO SUBS
        hash.subscriptions.push(sub)
      }
      self.$store.commit('cvc/setCVCParams', hash)
      // SETEANDO ADICIONALES PARAMETROS
      self.typeChangePayment = 'creditcard'
      self.dialogMethodPayment = false
      self.sectionEnterDataPayment = true
      self.loader = true
      setTimeout(function () {
        self.loadFormNiubiz()
      }, 1000)
    },
    getCardBrand: function (bin) {
      const filter = REGEX_CARDS.find((brand) => new RegExp(brand.re).test(bin))
      let brand = filter.value || ''
      if (brand === '') {
        brand = bin
      }
      return brand
    },
    goHome () {
      localStorage.setItem(KEY_CVC_SUCCESS, VALUE_NO)
      this.$router.push('/inicio')
    },
    closeDialogMethodPayment (evt) {
      this.polizasSeleccionadas = []
      this.polizasNoSeleccionadas = []
      this.productSelected = 0
      this.dialogMethodPayment = false
      this.sectionEnterDataPayment = false
      this.sectionThankPayment = false
      this.sectionCtaPayment = false
      this.cvcReload()
      evt.preventDefault()
    },
    makeChange () {
      this.sectionSuccessfullChangePayment = true
      this.sectionEnterDataPayment = false
    },
    onlyNumbers (e) {
      if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault()
      }
    },
    validateNumberCharacters (e) {
      if (e.target.value.length > 14) {
        e.preventDefault()
      } else if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault()
      }
    },
    getPolizasCustomer () {
      let self = this
      self.polizasVidaAvailable = []
      let data = { dni: self.basicInfo.numeroDocumento }
      self.getCustomerData(data).then(res => {
        if (res.status === 200 && res.data.codigoRespuesta === '01') {
          // self.polizasVidaAvailable = res.data.policies
          self.polizasVidaAvailable = res.data.policies // .filter(poliza => !poliza.policyName.toUpperCase().includes('VEHICULAR'))
        } else if (res.status === 200 && res.data.codigoRespuesta === '97') {
          // TRACK EVENT - GA
          this.$gtm.trackEvent(this.trackEvents.policiesNotFound)
          // TRACK EVENT - AMPLITUDE
          this.$amplitude.getInstance()
            .logEvent(
              this.amplitude.events.cVCChangeError,
              {
                'Seguros Seleccionados': '',
                'Emisor de la Tarjeta': '',
                'Frecuencia de Pago': '',
                'Cuota a Pagar': '',
                'Error': 'Polizas no encontradas'
              }
            )
          self.$swal({
            title: '¡Lo sentimos!',
            html: 'Este trámite no puede ser atendido por este medio, comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
            imageUrl: require('@/assets/characters/sorprendido.svg'),
            confirmButtonText: 'Entendido'
          }).then((result) => {
            this.$router.push('/inicio')
          })
        } else {
          // TRACK EVENT - GA
          self.$gtm.trackEvent(this.trackEvents.policiesError)
          // TRACK EVENT - AMPLITUDE
          self.$amplitude.getInstance()
            .logEvent(
              self.amplitude.events.cVCChangeError,
              {
                'Seguros Seleccionados': '',
                'Emisor de la Tarjeta': '',
                'Frecuencia de Pago': '',
                'Cuota a Pagar': '',
                'Error': 'Error al obtener polizas',
                'Detalle': res.data
              }
            )
          self.$swal({
            title: '¡Oops, algo salió mal!',
            text: 'Te pedimos disculpas por el inconveniente. Por favor, inténtalo nuevamente en unos minutos.',
            imageUrl: this.icons.oops,
            confirmButtonText: 'Entendido'
          }).then(() => {
            self.$router.push('/inicio')
          })
        }
      })
        .catch((err) => {
          // TRACK EVENT - GA
          self.$gtm.trackEvent(this.trackEvents.policiesError)
          // TRACK EVENT - AMPLITUDE
          self.$amplitude.getInstance()
            .logEvent(
              self.amplitude.events.cVCChangeError,
              {
                'Seguros Seleccionados': '',
                'Emisor de la Tarjeta': '',
                'Frecuencia de Pago': '',
                'Cuota a Pagar': '',
                'Error': 'Error al obtener polizas',
                'Detalle': err
              }
            )
          self.$swal({
            title: '¡Oops, algo salió mal!',
            text: 'Te pedimos disculpas por el inconveniente. Por favor, inténtalo nuevamente en unos minutos.',
            imageUrl: this.icons.oops,
            confirmButtonText: 'Entendido'
          }).then(() => {
            self.$router.push('/inicio')
          })
        })
    },
    loadNiubizSessionKey (callback) {
      let self = this
      // self.niubiz.dataSession.clientIP = this.ipInfo || localStorage.setItem(IP_ADDR) || self.niubiz.dataSession.clientIP
      // El BFF resuelve la apiKey y el comercio a partir de la póliza; el navegador no los envía
      let data = { ...self.niubiz.dataSession, numeroPoliza: self.polizasSeleccionadas[0].policyNumber }
      self.getSessionKey(data).then(res => {
        if (res.status === 200 && res.data.code === '01') {
          const merchantId = res.data.data.merchantId
          self.niubiz.configuration.merchantid = merchantId
          localStorage.setItem('merchant_id', merchantId)
          self.$store.commit('cvc/setCVCParams', { ...self.cvcInfo, merchant_id: merchantId })
          self.$store.state.user.niubizSessionKey = res.data.data.sessionKey
          callback(res.data.data.sessionKey)
          self.trackEvents.accessForm.producto = this.polizasSeleccionadas[0].policyNumber
          // TRACK EVENT - GA
          self.$gtm.trackEvent(this.trackEvents.accessForm)
        }
      })
        .catch((err) => {
          self.loader = false
          self.trackEvents.formError.producto = this.polizasSeleccionadas[0].policyNumber
          // TRACK EVENT - GA
          self.$gtm.trackEvent(this.trackEvents.formError)
          // TRACK EVENT - AMPLITUDE
          self.$amplitude.getInstance()
            .logEvent(
              self.amplitude.events.cVCChangeError, {
                'Seguros Seleccionados': '',
                'Emisor de la Tarjeta': '',
                'Frecuencia de Pago': '',
                'Cuota a Pagar': '',
                'Error': 'Error al obtener la sesión de Niubiz',
                'Detalle': err
              }
            )
          self.$swal({
            title: '¡Oops, algo salió mal!',
            text: 'Te pedimos disculpas por el inconveniente. Por favor, inténtalo nuevamente en unos minutos.',
            imageUrl: this.icons.oops,
            confirmButtonText: 'Entendido'
          }).then((result) => {
            this.$router.push('/inicio')
          })
        })
    },
    loadFormNiubiz () {
      let self = this
      let callback = function (sk) {
        self.niubiz.configuration.sessionkey = sk
        localStorage.setItem('niubizSessionKey', sk)
        self.loader = false
        self.dialogCardIndications = true
        self.niubiz.finishGetSessionKey = true
      }
      self.loadNiubizSessionKey(callback)
    },
    cvcReload () {
      this.$router.go(0)
    },
    // EVENTOS DEL COMPONENT NIUBIZ
    showTerms () {
      this.dialogTerms = true
    },
    showLoader (message) {
      this.loader2 = true
      this.txtLoader2 = message
    },
    hideLoader () {
      this.loader2 = false
    },
    onPaymentError (evt) {
      // error niubiz
      // console.log('Error niubiz: ', evt)
      if (self.cvcInfo) {
        this.trackEvents.serverError.producto = self.cvcInfo.subscriptions[0].objectId
      } else {
        this.trackEvents.serverError.producto = ''
      }
      this.$gtm.trackEvent(this.trackEvents.formError)
      this.$swal({
        title: '¡Parece que algo salió mal!',
        text: 'Te pedimos disculpas por el inconveniente. Por favor, inténtalo nuevamente en unos minutos.',
        imageUrl: this.icons.oops,
        confirmButtonText: 'Entendido'
      }).then(() => {
        this.retryCVC()
      })
      this.loader2 = false
    },
    retryCVC () {
      let self = this
      let retry = localStorage.getItem(KEY_CVC_RETRIES) || '0'
      retry = (parseInt(retry) + 1) + ''
      localStorage.setItem(KEY_CVC_RETRIES, retry)
      self.niubiz.configuration.merchantid = localStorage.getItem('merchant_id')
      // COMPLETANDO INFORMACIÓN DE POLIZA
      self.niubiz.configuration.purchasenumber = new Date().getTime() + ''
      self.niubiz.configuration.amount = parseFloat(1)
      self.niubiz.configuration.recurrentmaxamount = parseFloat(1)
      // COMPLETANDO INFORMACIÓN DE CLIENTE
      self.niubiz.pagador.name = self.removeAcents(self.basicInfo.nombres).slice(0, 24)
      self.niubiz.pagador.lastName = self.removeAcents(self.basicInfo.apellidoPaterno + ' ' + self.basicInfo.apellidoMaterno).slice(0, 24)
      self.niubiz.pagador.email = self.basicInfo.correo
      self.niubiz.pagador.alias = self.removeAcents(self.basicInfo.nombres).slice(0, 24)
      self.niubiz.pagador.userBlockId = self.basicInfo.numeroDocumento
      // COMPLETANDO INFORMACIÓN DE PAGO
      self.niubiz.dataSession.currency = self.cvcInfo.currency
      self.niubiz.dataSession.amount = parseFloat(1)
      // - INFORMACION: http://mdd.evirtuales.com/ con código 6300

      // SETEANDO ADICIONALES PARAMETROS
      self.typeChangePayment = 'creditcard'
      self.dialogMethodPayment = false
      self.sectionEnterDataPayment = true
      self.loader = true
      const sk = localStorage.getItem('niubizSessionKey')
      self.$store.state.user.niubizSessionKey = sk
      self.niubiz.configuration.sessionkey = sk
      self.loader = false
      // self.dialogCardIndications = true
      self.niubiz.finishGetSessionKey = true
      self.trackEvents.accessForm.producto = this.polizasSeleccionadas[0].policyNumber
      // TRACK EVENT - GA
      self.$gtm.trackEvent(this.trackEvents.accessForm)

      setTimeout(function () {
        self.loadFormNiubiz()
      }, 1000)
    },
    translateError (message) {
      const arr = [{key: 'Ã³', replace: 'ó'}, {key: 'Ã¡', replace: 'á'}, {key: 'Ã©', replace: 'é'}, {key: 'Ã­', replace: 'í'}, {key: 'Ã¹', replace: 'ú'}, {key: 'Ã±', replace: 'ñ'}]
      for (const err of arr) {
        message = message.replace(err.key, err.replace)
      }
      return message
    }
  },
  created () {
    const backReturn = localStorage.getItem(KEY_BACK_RETURN)
    const cvcSuccess = localStorage.getItem(KEY_CVC_SUCCESS)
    let queryParams = this.$route.query
    if (this.polizaInput && this.polizaInput !== null) {
      this.polizasSeleccionadas = [this.polizaInput]
    } else if (backReturn === VALUE_YES) {
      localStorage.setItem(KEY_BACK_RETURN, VALUE_NO)
      if (queryParams.bin == null && queryParams.channel == null && queryParams.transactionToken == null) {
        this.cvcReload()
        localStorage.setItem(KEY_CVC_SUCCESS, VALUE_NO)
      }
    } else if (!(queryParams.bin == null && queryParams.channel == null && queryParams.transactionToken == null) || cvcSuccess === VALUE_YES) {
      this.dialogCVC = false
      localStorage.setItem(KEY_BACK_HOME, VALUE_NO)
    } else {
      this.dialogCVC = true
      localStorage.setItem(KEY_BACK_HOME, VALUE_NO)
      // this.cvcReload()
    }
  },
  mounted () {
    let self = this
    self.niubiz.dataSession.clientIP = this.ipInfo || localStorage.setItem(IP_ADDR) || self.niubiz.dataSession.clientIP
    var today = new Date()
    var dd = today.getDate()
    var mm = today.getMonth() + 1
    var yyyy = today.getFullYear()
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    this.today = dd + '/' + mm + '/' + yyyy

    this.windowInnerWidth = window.innerWidth
    const backHome = localStorage.getItem(KEY_BACK_HOME)
    /*
    if (this.$vuetify.breakpoint.smAndDown) {
      document.querySelectorAll('#container--body-insurance')[0].classList.add('payment-method')
    }
    */
    // SI ESTA EN LOS PRIMEROS PASOS DE CAMBIO, DADO QUE AUN NO TENEMOS PARAMETROS QUE VENGAN DE PAYMENT-API
    let queryParams = this.$route.query
    let cvcSuccess = localStorage.getItem(KEY_CVC_SUCCESS)
    if (queryParams.bin == null && queryParams.channel == null && queryParams.transactionToken == null) {
      // LIMPIENDO EL FORM NIUBIZ PARA SER USADA NUEVAMENTE
      self.$store.commit('cvc/setCVCParams', null)
      // TRACK EVENT - GA
      // this.$gtm.trackEvent(this.trackEvents.access)
      if (backHome !== VALUE_YES) {
        self.getPolizasCustomer()
      }
    } else if (cvcSuccess === VALUE_YES) {
      // MOSTRANDO EL DIALOG DE FINALIZADO
      self.sectionSuccessfullChangePayment = true
    } else {
      // SI YA SOLICITO EL TOKEN. EL REDIRECT VIENE HACIA AQUI PARA SETEAR EL TOKEN
      let transactionToken = queryParams.transactionToken
      let bin = queryParams.bin
      // OBTENEMOS EL FORM YA COMPLETADO ANTERIORMENTE Y SETEAMOS EL TOKEN DEL PAYMENT-API
      self.cvcInfo.token = transactionToken
      self.cvcInfo.bin = bin
      // SETEAMOS EL TOKEN EN LOS SUBCRIPTIONS
      for (let index = 0; index < (self.cvcInfo.subscriptions).length; index++) {
        self.cvcInfo.subscriptions[index].metadataAffiliation.tarjeta.numerotarjeta = transactionToken
        self.cvcInfo.subscriptions[index].metadataAffiliation.tarjeta_pp.numerotarjeta = transactionToken
      }
      // MOSTRANDO EL DIALOG DE CARGANDO
      self.loader2 = true
      self.txtLoader2 = 'Corroborando información y generando el cambio...'
      // TRACK EVENT - AMPLITUDE
      var segurosSeleccionados = self.polizasSeleccionadas.length
      var frecuenciaPago = self.polizasSeleccionadas.map((el) => { return el.charge })
      var cuotaPagar = self.polizasSeleccionadas.map((el) => { return el.quota })
      var productoConsultados = self.polizasSeleccionadas.map((el) => { return el.policyName })
      // ENVIANDO DATA AL CVC Y REGISTRANDOLA
      self.registerCVC(self.cvcInfo)
        .then((res) => {
          self.loader2 = false
          if (res.data.code === '01' && res.data.message === 'SUCCESS') {
            // TRACK EVENT - AMPLITUDE
            localStorage.setItem(KEY_CVC_SUCCESS, VALUE_YES)
            localStorage.removeItem(KEY_CVC_RETRIES)
            localStorage.removeItem('merchant_id')
            localStorage.removeItem('apiKey')
            localStorage.removeItem('niubizSessionKey')
            self.$amplitude.getInstance()
              .logEvent(
                self.amplitude.events.cVCChangeConfirmation,
                {
                  'CVC Seguros seleccionados': segurosSeleccionados,
                  'Tipo de tarjeta': self.getCardBrand(bin),
                  'Frecuencia de pago': frecuenciaPago,
                  'Monto a pagar': cuotaPagar
                }
              )
            // TRACK EVENT - AMPLITUDE
            // MOSTRANDO EL DIALOG DE FINALIZADO
            self.sectionSuccessfullChangePayment = true
            self.cvcResponse = res.data.data

            self.trackEvents.cvcSuccess.producto = self.cvcInfo.subscriptions[0].objectId
            self.$gtm.trackEvent(this.trackEvents.cvcSuccess)
          } else {
            self.trackEvents.serverError.producto = self.cvcInfo.subscriptions[0].objectId
            // TRACK EVENT - GA
            self.$gtm.trackEvent(this.trackEvents.serverError)
            // TRACK EVENT - AMPLITUDE
            self.$amplitude.getInstance()
              .logEvent(
                self.amplitude.events.cVCChangeError,
                {
                  'Error': 'Error al realizar CVC',
                  'Detalle del error': res.data,
                  'Producto consultado': productoConsultados,
                  // 'Emisor de la Tarjeta': '',
                  'Tipo de tarjeta': self.getCardBrand(bin),
                  'Monto a pagar': cuotaPagar
                }
              )
            /* let message = this.translateError(res.data.message || 'Te pedimos disculpas por el inconveniente y solicitamos que vuelvas intentarlo en unos minutos.')
            if (message.toLowerCase().includes('bloqueada') || message.toLowerCase().includes('bloqueado')) {
              message = 'Tu tarjeta ha sido bloqueada por superar los intentos. Intenta con otra tarjeta o vuelva a intentarlo en las próximas horas.'
            } else if (message === 'Not Verified' || message.includes('500-0000') || message.includes('5000000')) {
              message = 'Te pedimos disculpas por el inconveniente y solicitamos que vuelvas intentarlo en unos minutos.'
            } */
            const error = paymentErrors.niubiz[res.data.providerCode] || paymentErrors.niubiz['']
            this.$swal({
              title: error.title,
              text: error.message,
              imageUrl: require('./../assets/payments/' + error.image + '.png'),
              confirmButtonText: 'Entendido'
            }).then(() => {
              self.retryCVC()
            })
          }
        })
        .catch((err) => {
          let message = this.translateError(err.message || 'Te pedimos disculpas por el inconveniente y solicitamos que vuelvas intentarlo en unos minutos.')
          /* let message = 'Te pedimos disculpas por el inconveniente y solicitamos que vuelvas intentarlo en unos minutos.'
          if ((err.message || '').toString().toLowerCase().includes('bloqueada')) {
            message = 'Tu tarjeta ha sido bloqueada por superar los intentos. Intenta con otra tarjeta o vuelva a intentarlo en las próximas horas.'
          } else if (err.message !== 'Not Verified' && !err.message.includes('500-0000') && !err.message.includes('5000000')) {
            message = err.message
          } */
          if (message.toLowerCase().includes('bloqueada') || message.toLowerCase().includes('bloqueado')) {
            message = 'Tu tarjeta ha sido bloqueada por superar los intentos. Intenta con otra tarjeta o vuelva a intentarlo en las próximas horas.'
          } else if (message === 'Not Verified' || message.includes('500-0000') || message.includes('5000000')) {
            message = 'Te pedimos disculpas por el inconveniente y solicitamos que vuelvas intentarlo en unos minutos.'
          }
          self.loader2 = false
          self.trackEvents.serverError.producto = self.cvcInfo.subscriptions[0].objectId
          // TRACK EVENT - GA
          self.$gtm.trackEvent(this.trackEvents.serverError)
          // TRACK EVENT - AMPLITUDE
          self.$amplitude.getInstance()
            .logEvent(
              self.amplitude.events.cVCChangeError,
              {
                'Error': 'Error inesperado al consultar el API de CVC',
                'Producto consultado': productoConsultados,
                'Tipo de tarjeta': self.getCardBrand(bin),
                'Frecuencia de Pago': '',
                'Cuota a Pagar': '',
                'Detalle Error': err
              }
            )
          this.$swal({
            title: '¡Parece que algo salió mal!',
            text: message,
            imageUrl: this.icons.oops,
            confirmButtonText: 'Entendido'
          }).then(() => {
            self.retryCVC()
            // this.$router.push('/inicio')
          })
        })
    }
  },
  computed: {
    ...mapGetters('user', ['polizasInfo', 'basicInfo', 'ipInfo', 'functionsRules']),
    ...mapGetters('cvc', ['cvcInfo']),
  },
  beforeDestroy: function () {
    /*
    if (this.$vuetify.breakpoint.smAndDown) {
      document.querySelectorAll('#container--body-insurance')[0].classList.remove('payment-method')
    }
    */
  },
  components: {
    Niubiz
  }
}
</script>

<style>
  @import url('../assets/css/payments.css');
  #btn-floatting {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    margin-bottom: 65px;
    height: 55px;
    background-color: var(--fuchsia-color);
  }
  /** CLASES GLOBALES CON IDENTIFICADOR PROPIO PORFA */
  @media only screen and (max-width: 600px) {
    .inicio-panel.cvc {
      margin-bottom: 150px;
      padding-bottom: 0;
    }
  }

  button.swal2-confirm.btn-response.swal2-styled {
      margin-top: 50px !important;
      margin-bottom: 20px !important;
      height: fit-content !important;
      text-transform: capitalize !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PaymentMehodChange.vue